<template>
  <div v-if="history.length" class="search-history">
    <div
      v-for="{ query, total, created } in history"
      :key="created"
      class="search-history__item"
      @click="handleHistoryItemSelected(query)"
    >
      <div class="search-history__title">{{ query ? query.text : '' }}</div>
      <div class="search-history__info">
        <strong>{{ total }}</strong
        >{{ created | formatDateTime }}
      </div>
    </div>
    <router-link
      v-if="history.length > 10"
      class="search-history__more"
      :to="'/home/search-history'"
    >
      Посмотреть всю историю
    </router-link>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      history: 'searchHistory'
    })
  },

  methods: {
    handleHistoryItemSelected(query) {
      this.$store.dispatch('loadRequestFromHistory', query);
      this.$emit('historyItemSelected', query);
    }
  }
};
</script>
